import {
    useOrganizationTaskGroupCounts,
    useOrganizationTaskGroups,
} from "@api/organizationTaskGroup.api";
import { TaskGroupsListBase } from "./TaskGroupsListBase";

interface Props {
    search: string;
    canManageTaskGroups: boolean;
}

export const OrganizationTaskGroupsList = ({
    search,
    canManageTaskGroups,
}: Props) => {
    const organizationTaskGroupsQuery = useOrganizationTaskGroups();
    const organizationTaskGroupCountsQuery = useOrganizationTaskGroupCounts();

    return (
        <TaskGroupsListBase
            search={search}
            canManageTaskGroups={canManageTaskGroups}
            taskGroups={organizationTaskGroupsQuery.data}
            isTaskGroupsFetched={organizationTaskGroupsQuery.isFetched}
            counts={organizationTaskGroupCountsQuery.data}
            isCountsFetched={organizationTaskGroupCountsQuery.isFetched}
            scope="organization"
        />
    );
};
